import { RepoFactory } from '@/baseRepository/Factory';
const tradeRequestsRepository = () => RepoFactory.get('tradeRequests');
const itemsRepository = () => RepoFactory.get('items');
import Helper from '@/core/helpers';

export const tradeRequestsActions = {
  getTradeRequests(context, params) {
    return new Promise((resolve, reject) => {
      tradeRequestsRepository()
        .getTradeRequests(
          context.getters.tradeBaseUrl,
          {
            MerchantId: context.getters.currentMerchant,
          },
          {
            ...params,
          }
        )
        .then((res) => {
          resolve(res.data.list);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addTradeRequest(context, { body, headers }) {
    return new Promise((resolve, reject) => {
      tradeRequestsRepository()
        .addTradeRequest(body, context.getters.tradeBaseUrl, {
          MerchantId: context.getters.currentMerchant,
          ...headers,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setHoldingCenter(context, params) {
    context.commit('setHoldingCenter', params);
  },
};
